import React, { FC } from 'react';
import { CaddyListProps } from './types';
import { Box } from '@bechtel/gds';
import { map } from 'lodash';
import { CaddyCard } from './card';
import { RodRequestCaddy } from '@bechtel/types';

export const CaddyList: FC<CaddyListProps> = ({ caddies, onEditCaddy, onDeleteCaddy, canEditCaddy }) => {
  return (
    <Box flexWrap={{ sm: 'wrap' }}>
      {map(caddies, (caddyItem: RodRequestCaddy, index) => {
        return (
          <Box key={index} pr={{ sm: '500' }} py={{ sm: '500' }}>
            <CaddyCard
              caddy={caddyItem}
              canEditCaddy={canEditCaddy}
              onEditCaddy={(caddy: RodRequestCaddy) => {
                if (!onEditCaddy) return;
                onEditCaddy(caddy);
              }}
              onDeleteCaddy={(caddy: RodRequestCaddy) => {
                onDeleteCaddy(caddy);
              }}
            />
          </Box>
        );
      })}
    </Box>
  );
};
